import * as types from '../constants/actionTypes';

const initialState = {
  isNoProfilePhotoPopupActive: false,
};

const toggleNoProfilePhotoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TOGGLE_NO_PHOTO_POPUP:
      return {
        ...state,
        isNoProfilePhotoPopupActive: action.data,
      };
    default:
      return state;
  }
};

export default toggleNoProfilePhotoReducer;
